import hooks from '@hooks'

const useIsInfluencerView = () => hooks.useQueryStringMatcher('viewType', 'influencer')

export { useIsInfluencerView }
